import { Pipe, PipeTransform } from '@angular/core';

import { deriveTimezoneDisplayName } from '@sondermind/utilities/time-and-date';

@Pipe({
  name: 'providerTimeZoneString',
  standalone: true,
})
export class ProviderTimeZoneStringPipe implements PipeTransform {
  transform(timeZone: string): string {
    return deriveTimezoneDisplayName(timeZone);
  }
}
